import { useEffect, useState } from 'react';
export function useTop(ref, offsetTop = 0) {
  const [top, setTop] = useState();
  useEffect(() => {
    function handleScroll() {
      if (ref.current) {
        const boundingRect = ref.current.getBoundingClientRect();
        setTop(boundingRect.top);
      }
    }
    document.addEventListener('scroll', handleScroll, {
      passive: true,
      capture: true
    });
    document.addEventListener('resize', handleScroll, {
      passive: true,
      capture: true
    });
    return () => {
      document.removeEventListener('scroll', handleScroll);
      document.removeEventListener('resize', handleScroll);
    };
  }, [ref]);
  return {
    isSticking: (top ?? offsetTop) < (offsetTop ?? 0),
    calculatedTop: (offsetTop ?? 0) - (top ?? 0)
  };
}